<template>
  <div class="project-add-content" id="masterFundRoot">
    <div class="detail-contents">
      <div class="detail-one">
        <div class="detail-content">
          <FundDetailForm
            ref="fundDetailForm"
            :disabled="false"
            :bindData="basicInfoData"
            :subFundsAdd="true"
          />
          <!-- <template v-for="(item, index) in buttonConfig">
              <Accessory
                :ref="item.id"
                :fileTitle="item.name"
                :key="`${item.id}-${index}`"
                :id="item.id"
                :idname="item.name"
                :upload="true"
                :projectid="id"
                :fileMenuUrlname="`基金附件-${item.name}`"
              />
          </template> -->
        </div>
      </div>
    </div>
    <template v-if="id>-1">
      <template v-for="(item, index) in buttonConfig">
        <Accessory
          v-if="item.isFile"
          :ref="item.id"
          :fileTitle="item.name"
          :key="`${item.id}-${index}`"
          :id="item.id"
          :idname="item.name"
          :upload="true"
          :projectid="id"
          :fileMenuUrlname="`其他子基金`"
          :isOnlyFile="true"
        />
      </template>
    </template>
    <!-- <InvestEventManage
    id="investManage"
              :ids="id"
        :edit="permission.otherSubFunds_edit ? true : false"
      /> -->

    <div style="height:40px;width:100%"></div>
    <div class="bottom-container" v-if="$route.params.id == -1||(permission.otherSubFunds_edit)">
      <div class="button-container">
        <!-- <el-button type="primary" @click="savePage(true)"  v-if="permission.otherSubFunds_edit">提交审核</el-button> -->
        <el-button plain type="primary" @click="savePage(false)" v-if="permission.otherSubFunds_edit"
          >保存</el-button
        >
      </div>
    </div>
    <!-- 电梯 -->
    <NavigatorBar
      v-if="id>-1"
      :buttonConfig="buttonConfig"
      rootId="masterFundRoot"
    />
  </div>
</template>
<script>
import FundDetailForm from "./components/fundDetailForm";
import { mapGetters } from "vuex";
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util";
import NavigatorBar from "@/components/navigatorBar/navigatorBar";
import Accessory from "@/components/accessoriesother/fundAccessory";
import {
  getSubFundDetail,
  submitFdsbasicinfo,
  auditSubmitFdsbasicinfo,
} from "@/api/fund/subfunds";
import InvestEventManage from "@/views/fund/masterfund/components/invesEventtManage";

export default {
  name: "subFundsNewAdd",
  mixins: [workFlow, util],
  data() {
    return {
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      loading: false,
      isLoading: false,
      firstQuery: false,
      // fundList: [],
      custList: [],
      queryData: {},
      companyInfoData: {},
      basicInfoData: {
        auditLogList: [],
        basicTrustee: {},
        basicManager: {},
      },
      buttonConfig: [{
            id: "el1",
            isFile: true,
            name: "市决策委员会",
          },
          {
            id: "el2",
            isFile: true,
            name: "内部决策",
          },
          {
            id: "el3",
            isFile: true,
            name: "投资协议",
          },
          {
            id: "el4",
            isFile: true,
            name: "投放审核",
          },
        ],   
      id: -1,
    };
  },
  watch: {},
  components: {
    FundDetailForm,
    NavigatorBar,
    Accessory,
    InvestEventManage
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
  },
  async mounted() {
    if (this.$route.params.id && this.$route.params.id > -1) {
      this.id = this.$route.params.id;
      this.querySubFundDetail(this.id);
    } else {
      this.id = await this.setNewId();
    }
  },

  methods: {
    async querySubFundDetail(id) {
      let res = {};

      res = await getSubFundDetail({ id: id });

      let basicInfoData = res.data.data;
      if (basicInfoData.auditLog) {
        basicInfoData.auditLogList = JSON.parse(basicInfoData.auditLog);
      }
      basicInfoData.industryList = basicInfoData.industry
        ? basicInfoData.industry.split(",")
        : [];
      let dataList = [{ code: "audit_state", name: "auditState" }];
      let dataSource = await this.dictionaryMap(dataList, basicInfoData);
      // dataSource.address = dataSource.domicile
      //   ? dataSource.domicile.split(",")
      //   : [];
      if (dataSource.basicInvestors&&dataSource.basicInvestors.length > 0) {
        dataSource.basicInvestors.map((item) => {
          if (item.capitals.length == 0) {
            item.capitals.push({});
          }
        });
      } else {
        dataSource.basicInvestors=[]
        dataSource.basicInvestors.push({
          capitals: [{}],
        });
      }
      this.basicInfoData = dataSource;
    },

    //  保存
    async savePage(startProcess) {
      let that = this;
      if (startProcess) {
        this.$confirm("是否确定提交审核?", "操作确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            that.getValidForm(startProcess);
          })
          .catch((res) => {
            that.$message({
              type: "info",
              message: "已取消",
            });
          });
      } else {
        that.getValidForm(startProcess);
      }
    },
    async getValidForm(startProcess) {
      let validRes = await this.$refs.fundDetailForm.validForm();

      if (validRes) {
        this.submitForm(startProcess);
      }
    },
    async submitForm(startProcess) {
      this.loading = true;
      let addFormInfo = this.$refs.fundDetailForm.addFormInfo;

      addFormInfo.basicInvestors.map((item) => {
        delete item.id;
        item.capitals.map((el) => {
          delete el.id;
        });
      });

      let params = {
        ...addFormInfo,
        // id:this.id,
        // domicile: addFormInfo.address ? addFormInfo.address.join(",") : "",
        bizType:3
      };

      // let apiName="submitFdbasicinfo"
      // if(startProcess){
      //   apiName="auditSubmitFdbasicinfo"
      // }
      let res = await submitFdsbasicinfo(params);
      this.loading = false;
      if (res.data.code == 200) {
        this.id = res.data.data.id;
        if (startProcess) {
          this.auditSubmit(res.data.data.id);
        } else {
          this.$router.push({
            path: `/otherFund/subFunds/subFundsDetail/${res.data.data.id}`,
          });
          this.$message({
            message: "保存成功",
            type: "success",
          });
        }
      }
    },
    //提交审核
    async auditSubmit(id) {
      let params = {
        id: id,
      };
      let res = await auditSubmitFdsbasicinfo(params);
      if (res.data.code == 200) {
        this.$router.push({
          path: `/otherFund/subFunds/subFundsDetail/${id}`,
        });
        this.$message({
          message: "提交审核成功",
          type: "success",
        });
      }
    },
  },
};
</script>
<style lang="scss">
// #avue-view {
//   margin-bottom: 70px;
// }
.project-add-content {
  width: 96%;
  margin: 0 auto;
  .el-autocomplete {
    width: 100%;
  }
  .detail-one {
    .detail-top {
      padding: 20px 5px;
      .detail-title {
        color: #666;
        font-weight: 700;
        font-size: 14px;
        line-height: 28px;
        position: relative;
      }
      .detail-title::before {
        content: "";
        width: 5px;
        background-color: #409eff;
        height: 18px;
        position: absolute;
        left: -12px;
        top: 5px;
      }
    }
    .stone-con {
      .stone-one {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #f7f9fe;
        padding: 10px;
        border: 1px solid #e4e4e4;
        border-radius: 4px;
        margin-bottom: 10px;
        .form-con {
          border-right: 1px dashed #e4e4e4;
        }
        .delete-con {
          width: 300px;
          height: 100%;
          text-align: center;
          i {
            font-size: 30px;
            color: #409eff;
          }
        }
        .el-collapse-item__wrap {
          background-color: #f7f9fe !important;
          border: none !important;
        }
        .el-collapse {
          border: none !important;
        }
        .el-form-item {
          margin-top: 14px !important;
          margin-bottom: 14px !important;
        }
      }
    }

    .add-btn {
      text-align: right;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
  .submit-con {
    text-align: center;
    margin-bottom: 40px;
    button {
      width: 150px;
    }
  }
  .loadmoresNO {
    font-weight: 400;
  }
  .loadmores {
    display: inline-block;
    text-align: center;
    line-height: 35px;
    font-size: 15px;
    color: #697289;
    padding: 0 20px;
    width: 100%;
    cursor: pointer;
    font-weight: 600;
  }
}
.bottom-container {
  width: 100%;
  height: 70px;
  position: fixed;
  // z-index: 1000;
  bottom: 0px;
  left: 0px;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.05);
  .button-container {
    width: 93%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>